"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _runtime = require("../runtime");
var _default = exports.default = (0, _runtime.IconWrapper)('loading', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("style", ['.kd-stroke-width-icon-regular{stroke-width:var(--kd-stroke-width-icon-regular, 1px); }.kd-color-icon-info{color:#1F69E0; color:var(--kd-color-icon-info, #1F69E0); }']), h("g", {
    "class": "kd-stroke-width-icon-regular kd-color-icon-info"
  }, [h("path", {
    "attrs": {
      "d": "M8 14C8.34071 14 8.67479 13.9716 9 13.917",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none",
      "stroke": "currentColor",
      "vector-effect": "non-scaling-stroke"
    }
  })]), h("g", {
    "class": "kd-stroke-width-icon-regular kd-color-icon-info"
  }, [h("path", {
    "attrs": {
      "d": "M8 14C11.3137 14 14 11.3137 14 7.99996C14 4.6863 11.3137 2 8 2",
      "stroke": 'url(#' + props.id + '2a78cf51' + ')',
      "stroke-linejoin": "round",
      "fill": "none",
      "vector-effect": "non-scaling-stroke"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '2a78cf51',
      "x1": "8",
      "y1": "12",
      "x2": "8",
      "y2": "3",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "offset": "0",
      "stop-color": "currentColor"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "currentColor",
      "stop-opacity": "0.5"
    }
  })])])]), h("g", {
    "class": "kd-stroke-width-icon-regular kd-color-icon-info"
  }, [h("path", {
    "attrs": {
      "d": "M8 2C4.68629 2 2 4.6863 2 8C2 11.3137 4.68629 14 8 14",
      "stroke": 'url(#' + props.id + '3a302073' + ')',
      "stroke-linejoin": "round",
      "fill": "none",
      "vector-effect": "non-scaling-stroke"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '3a302073',
      "x1": "7.5",
      "y1": "14",
      "x2": "8",
      "y2": "3",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "offset": "0",
      "stop-color": "currentColor",
      "stop-opacity": "0"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "currentColor",
      "stop-opacity": "0.5"
    }
  })])])])]);
});